
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-category-section');
  
  if (!sections.length) return;
  
  sections.forEach(section => {
    const categoryRow = section.querySelector('.category-row');
    const categoryBlocks = section.querySelectorAll('.category-block');
    const prevBtn = section.querySelector('.category-nav.prev');
    const nextBtn = section.querySelector('.category-nav.next');
    
    if (!categoryBlocks.length) return;
    
    // Check if we're in mobile view
    if (window.innerWidth < 768) {
      // Initially hide prev button as we start at first item
      if (prevBtn) prevBtn.classList.add('hidden');
      
      // Mobile scroll handling
      let touchStartX = 0;
      let touchEndX = 0;
      
      categoryRow.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      categoryRow.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) { // Minimum swipe distance
          if (diff > 0) {
            // Swipe left
            scrollToNextBlock();
          } else {
            // Swipe right
            scrollToPrevBlock();
          }
        }
      }
      
      function scrollToNextBlock() {
        const currentScroll = categoryRow.scrollLeft;
        const blockWidth = categoryBlocks[0].offsetWidth;
        categoryRow.scrollTo({
          left: currentScroll + blockWidth,
          behavior: 'smooth'
        });
      }
      
      function scrollToPrevBlock() {
        const currentScroll = categoryRow.scrollLeft;
        const blockWidth = categoryBlocks[0].offsetWidth;
        categoryRow.scrollTo({
          left: currentScroll - blockWidth,
          behavior: 'smooth'
        });
      }
      
      // Arrow button handlers
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', scrollToPrevBlock);
        nextBtn.addEventListener('click', scrollToNextBlock);
        
        // Update arrow visibility
        categoryRow.addEventListener('scroll', () => {
          const isStart = categoryRow.scrollLeft === 0;
          const isEnd = categoryRow.scrollLeft + categoryRow.offsetWidth >= categoryRow.scrollWidth - 10; // Small buffer
          
          prevBtn.classList.toggle('hidden', isStart);
          nextBtn.classList.toggle('hidden', isEnd);
        });
      }
    }
    
    // Improved scroll handler for all blocks
    window.addEventListener('scroll', () => {
      categoryBlocks.forEach(block => {
        const content = block.querySelector('.category-content');
        if (!content) return;
        
        const rect = block.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Reset any styles from other sections
        if (rect.bottom < 0 || rect.top > viewportHeight) {
          // Block is completely out of view - reset and hide
          content.style.opacity = '0';
          content.style.position = 'absolute';
          content.style.bottom = '2rem';
          content.style.top = 'auto';
          content.style.left = '2rem';
          content.style.right = '2rem';
          content.style.width = 'auto';
          return;
        }
        
        // Block is at least partially visible
        if (rect.top < viewportHeight && rect.bottom > 0) {
          // Calculate how much of the block is visible
          const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
          const visibilityRatio = visibleHeight / rect.height;
          
          // Only show content if block is significantly visible (at least 30%)
          if (visibilityRatio > 0.2) {
            content.style.opacity = Math.min(visibilityRatio * 2, 1).toString(); // Smooth fade in
            
            // Content positioning based on visibility
            if (rect.bottom <= viewportHeight) {
              // Block's bottom is in view, content should stick to block bottom
              content.style.position = 'absolute';
              content.style.bottom = '2rem';
              content.style.top = 'auto';
              content.style.left = '2rem';
              content.style.right = '2rem';
              content.style.width = 'auto';
            } else {
              // Bottom is not in view, fix content to viewport bottom
              content.style.position = 'fixed';
              content.style.bottom = '2rem';
              content.style.top = 'auto';
              
              // Align content with block
              content.style.left = `${rect.left + 32}px`;
              content.style.right = 'auto';
              content.style.width = `${rect.width - 64}px`;
            }
          } else {
            // Block is barely visible, fade out content
            content.style.opacity = '0';
          }
        }
      });
    });
  });
  
  // Trigger initial positioning
  const scrollEvent = new Event('scroll');
  window.dispatchEvent(scrollEvent);

  // Handle window resize to adjust for mobile/desktop changes
  let resizeTimeout;
  window.addEventListener('resize', () => {
    // Debounce resize event
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Trigger scroll event to reposition elements
      window.dispatchEvent(new Event('scroll'));
    }, 250);
  });
});
